import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';
import { JtnUiBtn } from '../jtn-ui-btn';
import { JtnUiShareRedesign, Events, Social } from '../jtn-ui-share-redesign';

import styles from './jtn-ui-share-popover.styles.scss?module';

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiSharePopover',
    props: {
      socials: {
        type: Array as () => Social[],
        required: false
      }
    },
    methods: {
      emitShared(event: string) {
        this.$emit('shared', event);
      },
      emitLinkCopied() {
        this.$emit('linkCopied');
      }
    },
    render() {
      return (
        <div class={[styles.shareWrapper]}>
          <JtnUiShareRedesign
            class={styles.shareBlock}
            isCaptionShown={false}
            isInOneLine={true}
            onShared={event => this.emitShared(event)}
            onLinkCopied={() => this.emitLinkCopied()}
            socials={this.socials}
          />
          <div class={[styles.actionBtn, styles.smallBtn]}>
            <svg width={24} height={24} slot="left">
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-share"></use>
            </svg>
          </div>
        </div>
      );
    }
  });
